const isProduction = process.env.REACT_APP_BUILD_TYPE === 'production';
const isStaging = process.env.REACT_APP_BUILD_TYPE === 'staging';

let publicbaseUrl = 'https://getset4education.co.uk';
let stripeKey = 'pk_live_4kM5QVsO0YETlXg1oaWyzieX';
if (!isProduction) {
  publicbaseUrl =
    'https://getset4pe-getset4education-public-v1.uat.avamae.co.uk';
  stripeKey = 'pk_test_VdhJmdlQLXHs2kZzwkyrvc4Q';
}

export const PUBLIC_SITE_URL = publicbaseUrl;
export const STRIPE_KEY = stripeKey;

export enum AppPath {
  ROOT = '/',
  DASHBOARD = '/dashboard',
  FORGOTTEN_PASSWORD = '/forgotten-password',
  RESET_PASSWORD = '/reset-password-schooluser',
  SET_PASSWORD = '/set-password-schooluser',
  NEW_SUBSCRIPTION = '/subscriptions/add-subscriptions',
  NEW_FREE_TRIAL = '/subscriptions/add-free-trial',
  UPGRADE_SUBSCRIPTION = '/upgrade-subscription',
  PROFILE = '/profile',
  MANAGEUSERS = '/manage-users',
  MANAGESCHOOL = '/manage-school',
  INVOICES = '/invoices',
  INVOICE_PAGE = 'template/subscription-invoice',
  SIGN_IN = '/sign-in',
  SUBSCRIBE = '/subscribe',
  SUBSCRIBE_FREE_TRIAL = '/free-trial',
  SUBSCRIPTIONS = '/subscriptions',
}

export enum NewSubscriptionPath {
  PAYMENT_DETAILS = '/payment-details',
  PAYMENT_TYPE = '/payment-type',
  ROOT = '/',
}

export enum SubscriptionTypes {
  STANDARD = 'Standard',
  INVESTEMENT = 'Investment',
}

export enum PaymentTypes {
  PAY_BY_CARD = 'Pay by card',
  PAY_BY_INVOICE = 'Pay by Invoice',
}

// export enum SubscriptionDuration {
//   ONE_YEAR = '1 Year',
//   THREE_YEARS = '3 Year',
//   FIVE_YEARS = '5 Year',
// }

export const ERROR_MESSAGE: string =
  'Oops, something went wrong. Please try again later.';
export const NO_ACCESS_MESSAGE: string =
  "You don't have permissions to access this page";
export const NOT_FOUND_PAGE: string = 'Page not found';
export const FALLBACK_ERROR_MESSAGE: string =
  'Please try again. If the error persists, please contact support.';

export const PASSWORD_REGEX = /^(?=.*[a-zA-Z])(?=.*\d)/;
export const PASSWORD_MATCH_POLICY_ERROR_MESSAGE =
  'Password must contain between  8 and 20 characters, and at least one number and one letter';
